import { observable } from "mobx";
import { Type } from "class-transformer";
import type { EntityValidationRules } from "../services/validationService";
import DecimalRangeRequest from "./decimalRangeRequest";
import { ApprovalState } from "./approvalState";
import RefundApprovalType from "./refundApprovalType";
import { RefundsSearchFilterValidationRules } from "./filters/refunds/refundsSearchFilter";
import TransferPaymentType from "./transferPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class PayGateToTransferRefundsRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  refundPaymentTemplateId?: string;

  @observable
  @Type(() => DecimalRangeRequest)
  refundAmount?: DecimalRangeRequest;

  @observable
  approvedBy?: RefundApprovalType;

  @observable
  notApprovedBy?: RefundApprovalType;

  @observable
  officialRecordId?: string;

  @observable
  transferType?: TransferPaymentType;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  terminalId?: string;

  @observable
  @Type(() => Date)
  authorizedDate?: Date;

  @observable
  variableSymbol?: number;

  @observable
  invoiceNumber?: string;

  @observable
  paidAmount?: number;

  @observable
  cardNumber?: string;

  @observable
  arn?: string;

  @observable
  payGatePaymentIdent?: string;
}

export default class PayGateToTransferRefunds extends PayGateToTransferRefundsRequest {
  @observable _approvalState?: ApprovalState;
}

export const PayGateToTransferRefundsRequestValidationRules: EntityValidationRules<PayGateToTransferRefunds> = {
  ...RefundsSearchFilterValidationRules,
  arn: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  invoiceNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  payGatePaymentIdent: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  terminalId: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
};
